module.exports = function () {
    $('.career-detail-buttons-apply').click(function() {
        var requisitionId = $(this).data('requisitionId');

        ICF.Modules.Analytics.TrackGoal('Apply Button Click', requisitionId);
    });

    $('.careers-detail-header__show-all-locations').click(function(e) {
        e.preventDefault();

        $('.careers-detail-header__location-item').removeClass('careers-detail-header__location-item--hidden');
        $(this).remove();
    });
}